import { Box, Typography } from '@mui/material';
import { Stack, styled } from '@mui/system';
import { format, getYear } from 'date-fns';
import { HeartWithUsers } from 'entities/heart-with-users';
import { User, UserRole } from 'entities/user';
import { weddingSelector } from 'entities/wedding';
import { logoImageWhite } from 'shared/assets';
import { BORDER_MAIN_BOLD, BORDER_RADIUS_XXL } from 'shared/config/theme/common';
import { useShallowSelector } from 'shared/hooks';
import { PolygonIcon } from 'shared/ui/components';
import { useTranslation } from 'react-i18next';
import {logoWhiteEngMinH, logoWhiteEngMinV, logoBlackEngMinH, logoBlackEngMinV, logoBlackEngH ,logoBlackEngV ,logoBlackRusH ,logoBlackRusV ,logoWhiteEngH ,logoWhiteEngV ,logoWhiteRusH ,logoWhiteRusV  } from 'shared/assets';
import {useEffect, useState} from "react";
import QrWeb3wed from '../../shared/assets/qrweb3wed.png'

const StyledSocialWithPicture = styled(Typography)<{ centered?: boolean; smallFont?: boolean }>`
  font-weight: 300;
  line-height: 1.25rem;
  font-size: 0.75rem;
  overflow: visible;
  color: #979797;
  text-overflow: ellipsis;
  padding: 0 0 ${({ theme }) => theme.spacing(2)} 0;
  font-size: 0.5rem;
 
  @media (max-width: 768px) {
    padding: 0 0 ${({ theme }) => theme.spacing(2)} 0;
    font-size: 0.5rem;
  }  
  ${({ smallFont, theme }) =>
    smallFont &&
    `
  ${theme.breakpoints.down('md')} {
    font-size: 0.75rem;
    line-height: 1rem;
} 
`}

  ${({ centered }) => centered && 'grid-row: 1 / 3'}
`;
export const BorderWrapper = styled(Stack)(({ theme }) => ({
  position: 'relative',
  border: BORDER_MAIN_BOLD,
  borderRadius: BORDER_RADIUS_XXL,
  alignItems: 'center',
  padding: theme.spacing(3, 4, 2.25),
  width: 380,
  minHeight: 660,
  [theme.breakpoints.down('md')]: {
    minWidth: 'unset',
      width: 380,
      minHeight: 660,
  },
  '*': {
    textAlign: 'center',
  },
}));
type CertificateUserProps = {
  firstName: string;
  lastName: string;
  avatar: string;
  ringImg: string;
};

type CertificateContainerProps = {
  femaleProps: CertificateUserProps;
  manProps: CertificateUserProps;
};
export const CertificateContainer = ({ femaleProps, manProps }: CertificateContainerProps) => {
  const { t, i18n } = useTranslation();
  const { witness, certificate, marriedAt, payment } = useShallowSelector(weddingSelector.getWedding);
  console.log(useShallowSelector(weddingSelector.getWedding));
    const [curentLogo, setcurentLogo] = useState(logoWhiteEngH);
    useEffect(() => {
        if(i18n.language == 'ru') {
            setcurentLogo(logoBlackEngMinH)
        } else {
            setcurentLogo(logoBlackEngMinH)
        }
    }, [i18n.language]);
  const date = new Date(marriedAt || 0);
  const witnessDisplayData = witness
    ? {
        firstName: witness.user?.firstName || '',
        lastName: witness.user?.lastName || '',
        avatar: witness.user?.profileImage || '',
      }
    : null;
  return (
    <BorderWrapper pb={{xs: '120px'}} overflow="hidden">
      <Stack direction="row" justifyContent="space-between" width="100%">
        <Typography className="secondary" sx={{fontSize: '15px'}}>#{certificate?.externalTokenId || payment?.tokenId}</Typography>
          <Typography className="center primary">
              <Box component="img" src={logoBlackEngMinV} alt="web3wed logo" sx={{ width: 90, position: 'relative', left: '0', bottom: '0', mb: 'auto', mt: 'auto' }} />
          </Typography>
        <PolygonIcon />
      </Stack>
      <Stack spacing={2} alignItems="center" mt={2}>
        <Typography variant="h3" className="center primary" sx={{lineHeight: '35px', fontSize: {
                //md: '30px',
                xs: '22px',
            }, textTransform: 'inherit',fontWeight: '400'}}>
          {t('certificate_Container_1')}
        </Typography>
        <Typography variant="h6" className="center" sx={{lineHeight: '35px',
        fontSize: {
            xs: '0.825rem',
        }}}>
            {format(date, 'do')} {t('certificate_Container_5')} {format(date, 'LLLL')} {getYear(date)}
        </Typography>
      </Stack>
      <Stack spacing={2} alignItems="center" my={3} mt={{
          xs: 4.5,
          //md: 7
      }}>

        <HeartWithUsers size="mlarge" femaleProps={femaleProps} manProps={manProps} />
          {/*<Typography variant="body2" className="center">
            {t('certificate_Container_7')}
          <br />
          <Typography component="span" variant="h4" className="secondary blue" fontSize={30}>
              {t('certificate_Container_8')}
          </Typography>
        </Typography>
        <Typography variant="body2" className="center">
            {t('certificate_Container_9')} <br /> {t('certificate_Container_10')}
        </Typography>
        {witnessDisplayData ? (
          <>
            <User {...witnessDisplayData} role={UserRole.Witness} simple size="medium" />
            <Typography variant="subtitle1" className="primary" fontSize={16}>
                {t('certificate_Container_11')} {`${witnessDisplayData?.firstName || ''} ${witnessDisplayData?.lastName || ''}`}
            </Typography>
          </>
        ) : (
          <Typography variant="subtitle1" className="primary" fontSize={16}>
              {t('certificate_Container_12')}
          </Typography>
        )}*/}
      </Stack>
        {/*<Box component="img" src={femaleProps.ringImg} alt="ring" sx={{
            width: {
                xs: 250,
                md: 475,
            },
            height: {
                xs: 250,
                md: 475,
            },
            position: 'absolute',
            left: {
                xs: '-140px',
                md: '-220px',
            },
            bottom: {
                xs: '290px',
                md: '230px',
            },
            mb: '35px',
            mt: 'auto'
        }}/>
        <Box component="img" src={manProps.ringImg} alt="ring " sx={{

            width: {
                xs: 250,
                md: 475,
            },
            height: {
                xs: 250,
                md: 475,
            },
            position: 'absolute',
            right: {
                xs: '-140px',
                md: '-220px',
            },
            bottom: {
                xs: '290px',
                md: '230px',
            },
            mb: '35px',
            mt: 'auto'}} />*/}
        <Typography className="primary center" sx={{fontSize: '15px', mb: 2, position: 'absolute', bottom: '10px', display: 'flex', alignItems: 'center', flexDirection: 'column'}}>
            <Box
                component="img"
                src={certificate?.qrCodeUrl || QrWeb3wed}
                alt=""
                sx={{
                    width: 80,
                    height: 80,
                    borderRadius: '5px', 
                    mb: '15px'
                }}
            />
            <StyledSocialWithPicture>
                {t('certificate_Container_2')}
            </StyledSocialWithPicture>
        </Typography>
    </BorderWrapper>
  );
};
